// eslint-disable-next-line @atlaskit/design-system/use-spotlight-package
import { Spotlight } from '@atlaskit/onboarding';
import { token } from '@atlaskit/tokens';
import { useIntl } from 'react-intl-next';

import { messages } from './messages';

export const FilterSpotlight = ({
	onNext,
	onDismiss,
}: {
	onNext: () => void;
	onDismiss: (isTourCompleted?: boolean) => void;
}) => {
	const { formatMessage } = useIntl();

	return (
		<Spotlight
			actions={[
				{
					onClick: onNext,
					text: formatMessage(messages.nextButton),
				},
				{
					onClick: () => onDismiss(),
					text: formatMessage(messages.dismissButton),
					appearance: 'subtle',
				},
			]}
			target="jql-builder.ui.jql-builder.editor"
			key="jql-builder.ui.jql-builder.editor"
			targetRadius={3}
			dialogWidth={285}
			targetBgColor={token('elevation.surface')}
			actionsBeforeElement={<>1/2</>}
			testId="filter-spotlight"
		>
			{formatMessage(messages.filterSpotlightMessage)}
		</Spotlight>
	);
};
